module.exports = __webpack_public_path__ + "static/home-compressed-ac9eb6481659ff21480c72d12b97d21e.mp4";